import useMenuRedirect from 'containers/Menu/hooks/useMenuRedirect';
import React, { useState } from 'react';
import HtmlDecode from 'utils/htmlDecode';
//-----------------------------------------------------------------------------
import CustomSelect from '../../../../components/CustomSelect';
import './style.scss';
import { findNestedNode } from '../../../../utils/nodes/findNestedNode';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';
import MobileSelectModal from 'components/MobileSelectModal';

export const FiltersContainer = ({
  ordering,
  currentGenre,
  setOrderingFetch,
  selectedOrder,
  setSelectedOrder,
}) => {
  const { nodesSelected, nodes, handleRedirect } = useMenuRedirect();
  const genres = findNestedNode(nodes, 'id', nodesSelected?.id_parent)?.childs;
  const [selectedFilter, setSelectedFilter] = useState(
    genres?.find(genre => genre.code === currentGenre).text,
  );
  const { isMobile } = useVerifyIsMobile(768);
  const [filtersVisible, setFiltersVisible] = useState(false);
  const [orderingVisible, setOrderingVisible] = useState(false);

  const onSelectGenre = (e, node) => {
    setSelectedFilter(e.target.textContent);
    handleRedirect({ node });
  };

  const onSelectNewOrdering = (e, order) => {
    setSelectedOrder(e.target.textContent);
    setOrderingFetch(order);
    setOrderingVisible(false);
  };

  if (ordering === undefined) return null;
  
  return (
    <div className="filter-container">
      {isMobile ? (
        <>
          <MobileSelectModal
            selected={selectedFilter}
            show={filtersVisible}
            setShow={setFiltersVisible}
            position="start"
            withMaxWidth={true}
          >
            {genres?.map(genre => (
              <li
                className={
                  selectedFilter === genre.text ? 'selected' : 'unselected'
                }
                key={genre.id}
                onClick={e => onSelectGenre(e, genre)}
              >
                {genre.text}
              </li>
            ))}
          </MobileSelectModal>
          <MobileSelectModal
            selected={selectedOrder}
            show={orderingVisible}
            setShow={setOrderingVisible}
            position="start"
            withMaxWidth={true}
          >
            {ordering.map(({ label, order }) => (
              <li
                key={order}
                className={
                  selectedOrder === HtmlDecode(label)
                    ? 'selected'
                    : 'unselected'
                }
                onClick={e => onSelectNewOrdering(e, order)}
              >
                {HtmlDecode(label)}
              </li>
            ))}
          </MobileSelectModal>
        </>
      ) : (
        <>
          <CustomSelect selected={selectedFilter}>
            {genres?.map(genre => (
              <li key={genre.id} onClick={e => onSelectGenre(e, genre)}>
                {genre.text}
              </li>
            ))}
          </CustomSelect>
          <CustomSelect selected={selectedOrder}>
            {ordering.map(({ label, order }) => (
              <li key={order} onClick={e => onSelectNewOrdering(e, order)}>
                {HtmlDecode(label)}
              </li>
            ))}
          </CustomSelect>
        </>
      )}
    </div>
  );
};
